// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: 'Dashboard',
      icon: 'fa-light fa-table-columns',
      to: '/',
    },
    {
      title: 'Bestellingen',
      icon: 'fa-light fa-boxes-stacked',
      to: '/orders',
    },
    {
      title: 'Tijd blokken',
      icon: 'fa-light fa-clock',
      to: '/timeblock',
    },
    {
      title: 'Producten',
      icon: 'fa-light fa-shirt',
      to: '/products',
    },
    {
      title: 'Vakken',
      icon: 'fa-regular fa-square',
      to: '/section',
    },
    {
      title: 'Abonnementen',
      icon: 'fa-light fa-credit-card-blank',
      to: '/subscriptions',
    },
    {
      title: 'Gebruikers',
      icon: 'fa-light fa-users',
      to: '/users',
    },
    // {
    //   title: 'Regular Tables',
    //   icon: 'mdi-clipboard-outline',
    //   to: '/tables/regular/',
    // },
    // {
    //   title: 'Typography',
    //   icon: 'mdi-format-font',
    //   to: '/components/typography/',
    // },
    // {
    //   title: 'Icons',
    //   icon: 'mdi-chart-bubble',
    //   to: '/components/icons/',
    // },
    // {
    //   title: 'Google Maps',
    //   icon: 'mdi-map-marker',
    //   to: '/maps/google/',
    // },
    // {
    //   title: 'Notifications',
    //   icon: 'mdi-bell',
    //   to: '/components/notifications/',
    // },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
